module.exports = __webpack_public_path__ + "media/images/founders/founder_2-98568ab61a1399dbc35cefc94bbf6086.jpg";